import * as csstree from 'css-tree';

const forbiddenProperties = ['expression', 'behavior', '-moz-binding', 'url'];
const urlRegex =
  /^url\(["']?(assets\/[a-zA-Z0-9\-_/]+\.(jpg|jpeg|png|svg|webp))["']?\)$/;

const isSafeFilter = (value: string): boolean => {
  const normalized = value.trim().toLowerCase();
  const regex = /url\(\s*(?:"([^"]+)"|'([^']+)'|([^'")\s]+))\s*\)/gi;
  let match: RegExpExecArray | null;

  while ((match = regex.exec(normalized)) !== null) {
    const url = (match[1] || match[2] || match[3]).trim();

    if (
      url.startsWith('javascript:') ||
      url.startsWith('data:') ||
      url.startsWith('vbscript:')
    ) {
      return false;
    }
  }

  return true;
};

export const sanitizeStyles = (cssText: string): string => {
  const ast = csstree.parse(cssText, {
    parseValue: true,
    parseCustomProperty: true,
  });

  csstree.walk(ast, {
    visit: 'Rule',
    enter: (node, item, list) => {
      if (node.type === 'Rule' && node.block && node.block.children) {
        node.block.children.forEach((declarationItem) => {
          if (declarationItem.type === 'Declaration') {
            const property = declarationItem.property;
            const value = csstree.generate(declarationItem.value);

            if (forbiddenProperties.includes(property)) {
              list.remove(item);
            }

            if (property === 'background-image' && !urlRegex.test(value)) {
              list.remove(item);
            }

            if (property === 'filter' && !isSafeFilter(value)) {
              list.remove(item);
            }
          }
        });
      }
    },
  });

  return csstree.generate(ast);
};
